export default __webpack_public_path__ + "static/media/tick-icon.d6ee7092.svg";